module.exports = require("@material-ui/core/Tab");